import React, { FC } from 'react'

import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Theme
} from '@material-ui/core'
import { BoxProps } from '@material-ui/core/Box'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import NavigateNext from '@material-ui/icons/NavigateNext'

import Link from '~/components/shared/Link'

import { ILink } from '~/interfaces/shared'

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      breadcrumb: {
        fontSize: '14px',
        color: (props: { dark: boolean }) =>
          props.dark ? theme.palette.text.primary : theme.palette.common.white
      },
      container: {
        '& .MuiBreadcrumbs-separator': {
          margin: 0
        }
      }
    }),
  { name: 'Breadcrumbs' }
)

interface Props extends Omit<BoxProps, 'color'> {
  items: ILink[]
  withHome?: boolean
  color?: 'dark' | 'light'
}

const Breadcrumbs: FC<Props> = ({
  items,
  withHome = true,
  color = 'dark',
  ...rest
}) => {
  const dark = color === 'dark'
  const classes = useStyles({ dark })

  return (
    <Box pt={2.5} {...rest}>
      <MuiBreadcrumbs
        separator={
          <NavigateNext fontSize="small" style={{ color: '#2896DE' }} />
        }
        aria-label="breadcrumb"
        className={classes.container}
      >
        {withHome && (
          <Link href="/" className={classes.breadcrumb}>
            Homepage
          </Link>
        )}
        {items.map((item, index) => {
          if (index !== items.length - 1) {
            return (
              <Link
                key={item.href}
                href={item.href}
                className={classes.breadcrumb}
              >
                {item.child}
              </Link>
            )
          }

          return (
            <Box key={item.href} color={dark ? 'text.secondary' : 'grey.400'}>
              <Typography style={{ fontSize: '14px' }}>{item.child}</Typography>
            </Box>
          )
        })}
      </MuiBreadcrumbs>
    </Box>
  )
}

export default Breadcrumbs
